import { catalogueReportApi } from "../../services/CatalogueServices";
import { acquisitionsReportApi } from "../../services/AcquisitionServices";
import { conservationReportApi } from "../../services/ConservationServices";
import { loansReportApi } from "../../services/LoanServices";
import { transferReportApi } from "../../services/TransferServices";
import { deaccessionReportApi } from "../../services/DeaccessionServices";

export const handleDownload = async (tabIndex) => {
  try {
    let response;
    let filename;

    if (tabIndex === 0) {
      response = await catalogueReportApi("get");
      filename = "Catalogue_Data.csv";
    } else if (tabIndex === 1) {
      response = await acquisitionsReportApi("get");
      filename = "Acquisitions_Data.csv";
    } else if (tabIndex === 2) {
      response = await conservationReportApi("get");
      filename = "Conservation_Data.csv";
    } else if (tabIndex === 3) {
      response = await loansReportApi("get");
      filename = "Loans_Data.csv";
    } else if (tabIndex === 4) {
      response = await transferReportApi("get");
      filename = "Transfer_Data.csv";
    } else if (tabIndex === 5) {
      response = await deaccessionReportApi("get");
      filename = "Deaccession_Data.csv";
    }
    const blob = new Blob([response], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the CSV file", error);
  }
};
